module.exports = __webpack_public_path__ + "img/bg_num.76d5926f.png";